/**
 * The two tabs of the Transfers sheet (kitecorp/transferify-ui#3140): the files this account SENT, and the
 * files it REQUESTED from its contacts. Requests lived on their own Reminders screen until the owner moved
 * them under Transfers (2026-09-29).
 *
 * The tab is chosen by the URL, the way every feature sheet is chosen by its path (`/account/admin` opens
 * the operator queue the same way): `/transfers` is Sent and `/transfers/requested` is Requested, so a link,
 * the back button and a reload all land on the tab they named. A nested PATH rather than a query parameter,
 * because the edge function and the client-only shell already serve every path under `/transfers` by its
 * first segment, so the new tab needed no second list anywhere.
 *
 * React-free on purpose (epic #26): a route rule, testable without rendering.
 */

export type TransfersTab = "sent" | "requested";

/** Where the Sent tab lives: the Transfers sheet's own route. */
export const TRANSFERS_ROUTE = "/transfers";

/** Where the Requested tab lives, and where the retired `/reminders` route now sends its old links. */
export const REQUESTED_FILES_ROUTE = "/transfers/requested";

/** Which tab `pathname` shows. Anything under `/transfers` that is not the Requested tab is Sent. */
export function transfersTabFor(pathname: string): TransfersTab {
	const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
	return path === REQUESTED_FILES_ROUTE ? "requested" : "sent";
}

/** The path that shows `tab`. */
export function transfersTabPath(tab: TransfersTab): string {
	return tab === "requested" ? REQUESTED_FILES_ROUTE : TRANSFERS_ROUTE;
}
